export const getMenuPermissions = (menu, menuName, submenuName, permission) => {
  const menuOptions = menu?.filter((option) => option.nombre === menuName);
  if (submenuName) {
    if (menuOptions !== null && menuOptions !== undefined) {
      const subMenuOptions = menuOptions[0]?.subMenus?.filter(
        (option) => option.nombre === submenuName
      );
      const permisos = subMenuOptions[0]?.permisos.split(',');
      if (permisos !== null && permisos !== undefined) {
        for (let i = 0; i < permisos.length; i += 1) {
          if (permisos[i] === permission) {
            return true;
          }
        }
      }
    }
    return false;
  }
  if (menuOptions !== null && menuOptions !== undefined) {
    const permisos = menuOptions[0]?.permisos?.split(',');
    if (permisos !== null && permisos !== undefined) {
      for (let i = 0; i < permisos.length; i += 1) {
        if (permisos[i] === permission) {
          return true;
        }
      }
    }
  }
  return false;
};
